import { code } from './customcode'
// import buildSummaryProjects from './buildSummaryProjects'
// import showOnReport from './showOnReport'

const RunScripts = () => {
  code()
  // buildSummaryProjects()
  // showOnReport()
}

export default RunScripts



// WEBPACK FOOTER //
// ./src/scripts/RunScripts.js